import React from 'react'
import MakerPage from './maker/MakerPage'

const App = () => (
  <div className="App">
    <MakerPage />
  </div>
)

export default App
